import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "swiper/css";
import "swiper/css/autoplay";

import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./Pages/HomePage/HomePage";
import MCQService from "./Pages/homework-help/MCQService/index";
import TrueFalseService from "./Pages/homework-help/TrueFalseService/index";
import FillupsService from "./Pages/homework-help/FillUps";
import ShortAnswerService from "./Pages/homework-help/ShortAnswerService";
import MatchTheFollowing from "./Pages/homework-help/MatchTheFollowing";
import Definition from "./Pages/homework-help/definition";
import AssignmentWriting from "./Pages/assignment-help/AssignmentWriting";
import ProjectLabReportWriting from "./Pages/assignment-help/ProjectLabReportWriting";
import EssayWriting from "./Pages/assignment-help/EssayWriting";
import PresentationWriting from "./Pages/assignment-help/PresentationWriting";
import ArticleWriting from "./Pages/assignment-help/ArticleWriting";
import SpeechWriting from "./Pages/assignment-help/SpeechWriting";
import LiveSessionChatHelp from "./Pages/live-session-help/1-to-1-chat-help";
import LiveSessionVideoHelp from "./Pages/live-session-help/1-to-1-video-help";
import { Suspense, useEffect, useState } from "react";
import BillingAddress from "./Components/OrderStatusAndBilling/BillingAddress";
import CheckOut from "./Components/OrderStatusAndBilling/CheckOut";
import { loadStripe } from "@stripe/stripe-js";
import Completion from "./Components/OrderStatusAndBilling/Completion";
import Dashboard from "./Pages/dashboard/Dashboard";
import DashboardHome from "./Pages/dashboard/DashboardHome";
import DashboardOrderHistory from "./Pages/dashboard/DashboardOrderHistory";
import DashboardQuestions from "./Pages/dashboard/DashboardQuestions";
import DashboardAnswer from "./Pages/dashboard/DashboardAnswer";
import Dashboardview from "./Pages/dashboard/Dashboardview";
import DashboardLibrary from "./Pages/dashboard/DashboardLibrary";
import DashboardFaq from "./Pages/dashboard/DashboardFaq";
import DashboardContactUs from "./Pages/dashboard/DashboardContactUs";
import { checkToken } from "./services/checkToken";
import { isLoggedIn } from "./hooks/useIsLoggedIn";
import OopsError from "./Components/OrderStatusAndBilling/OopsError";
import { CategoryContext } from "./categoryContext";
import { ChatNotificationProvider } from "./context/ChatNotificationContext";
import Search from "./Pages/search/Search";
import Refundpolicy from "./Pages/Staticpages/Refundpolicy";
import Faq from "./Pages/Staticpages/Faq";
import Authentication from "./Pages/auth/Auth";
import Earnmoney from "./Pages/dashboard/Earnmoney";
import PersonalSetting from "./Pages/dashboard/PersonalSetting";
import Dashboardviewlive from "./Pages/dashboard/Dashboardviewlive";
import ViewLibraryAnswer from "./Pages/search/ViewLibraryAnswer";
import Libraryviewabswer from "./Pages/dashboard/Libraryviewabswer";
import Razorpay from "./Components/OrderStatusAndBilling/Razorpay";
import Reviews from "./Pages/Staticpages/Reviews";
import DoubtQ from "./Assets/logo/loader dobutq.gif";
import Comingsoon from "./Pages/Staticpages/Comingsoon";
import Register from "./Pages/auth/Register";
import Login from "./Pages/auth/Login";
import SignUp from "./Components/Popup/Register";
import SignIn from "./Components/Popup/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./Pages/auth/ForgotPassword";
import Resetpassword from "./Pages/auth/Resetpassword";
import RazorpayCompletion from "./Components/OrderStatusAndBilling/RazorpayCompletion";
import Library from "./Pages/search/Library";
import Referralprogram from "./Pages/dashboard/Referralprogram";
import NotificationPopup from "./Components/NotificationPopup";
import AllSubjects from "./Pages/all-subjects/AllSubjects";
import PracticePapers from "./Pages/exam-preparation/PracticePapers";
import ExamPreparation from "./Pages/exam-preparation/ExamPreparation";
import ExamPrepHistory from "./Pages/dashboard/ExamPrepHistory";
import DashboardThankYou from "./Pages/dashboard/DashboardThankYou";
import QuestionBank from "./Pages/exam-preparation/QuestionBank";
import SepcialStudyNote from "./Pages/exam-preparation/SepcialStudyNote";
import SubjectSubcategory from "./Pages/all-subjects/SubjectSubcategory";
import SubjectCategory from "./Pages/all-subjects/SubjectCategory";
import UniversityList from "./Pages/university/UniversityList";
import ParticularUniversity from "./Pages/university/ParticularUniversity";
import Question from "./Pages/questions/Question";
import ThankYou from "./Pages/thankyou/ThankYou";
import ParticularCourse from "./Pages/course/ParticularCourse";
import PayNow from "./Pages/paynow/PayNow";
import AfterUniversity from "./Pages/university/AfterUniversity";
import Demo from "./Pages/Demo";
import DashboardUniversity from "./Pages/dashboard/DashboardUniversity";
import DashboardParticularCourse from "./Pages/dashboard/DashboardParticularCourse";
import DashboardPaynow from "./Pages/dashboard/DashboardPaynow";
import DashboardOrd from "./Pages/dashboard/DashboardOrd";
import CourseCheckOut from "./Pages/dashboard/CourseCheckOut";
import BillingAddressCourse from "./Components/OrderStatusAndBilling/BillingAddressCourse";
import TrackOrder from "./Pages/dashboard/TrackOrder";
import TopHead from "./Components/TopHead";
import AssignmentHelp from "./Pages/assignment-help/AssignmentHelp/indes";
import ProjectReportWriting from "./Pages/assignment-help/ProjectReportWriting";
import ReseachPaper from "./Pages/assignment-help/ReseachPaper";
import VideoSolutions from "./Pages/assignment-help/VideoSolutions";
import DashboardviewHomework from "./Pages/dashboard/DashboardviewHomework";
import BlogsList from "./Pages/blogs/BlogsList";
import BlogsDetail from "./Pages/blogs/BlogsDetail";
import CheckoutContainer from "./Components/OrderStatusAndBilling/CheckOutStep/CheckoutContainer";
import { SubSubjectsProvider } from "./context/SubSubjectsContext";
import Footer from "./Components/Footer";
function RequireAuth({ children }) {
  const [checkFlag, setCheckFlag] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const result = await isLoggedIn();
      setCheckFlag(result);
    };

    fetchData();
  }, []);

  if (checkFlag === null) {
    return (
      <div>
        <img
          src={DoubtQ}
          alt="DoubtQ Logo"
          width={100}
          height={100}
          style={{ position: "relative", top: "300px" }}
        />
      </div>
    );
  }

  if (!checkFlag) {
    return <Navigate to="/" />;
  }
  return children;
}
function CheckRoutes({ children }) {
  const [checkFlag, setCheckFlag] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const result = await isLoggedIn();
      setCheckFlag(result);
    };

    fetchData();
  }, []);

  if (checkFlag === null) {
    return (
      <div>
        <img
          src={DoubtQ}
          alt="DoubtQ Logo"
          width={100}
          height={100}
          style={{ position: "relative", top: "300px" }}
        />
      </div>
    );
  }

  if (checkFlag) {
    return <Navigate to="/dashboard/home" />;
  }
  return children;
}
function App() {
  const [categoryId, setCategoryId] = useState("655656ddb9cbef8acade1d64");
  const { pathname } = useLocation();
  function ScrollToTop() {

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    const verifyToken = async () => await checkToken();
    verifyToken();
    return null;
  }

  const hideFooterRoutes = [
  "/login",
  "/register",
  "/signin",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/paynow",
  "/checkout",
  "/dashboard"
];
const shouldHideFooter = hideFooterRoutes.some(route => pathname.startsWith(route));

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
  const razorpayPromise = loadStripe(process.env.REACT_APP_RAZORPAY_KEY_ID);

  return (
    <>
      <div className="App">
        <ChatNotificationProvider>
          <CategoryContext.Provider value={{ categoryId, setCategoryId }}>
            <SubSubjectsProvider>
              <ScrollToTop />
              <NotificationPopup />
              <Suspense
                fallback={
                  <div  sclassName="loader-container">
                    <img
                      src={DoubtQ}
                      alt="DoubtQ Logo"
                      width={100}
                      height={100}
                      style={{ position: "relative", top: "300px" }}
                    />
                  </div>
                }
              >
                <TopHead />
                 <div style={{ flex: 1 }}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <CheckRoutes>
                        <HomePage />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/auth"
                    element={
                      <CheckRoutes>
                        <Authentication />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/login"
                    element={
                      <CheckRoutes>
                        <Login />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/register"
                    element={
                      <CheckRoutes>
                        <Register />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/register/:referral"
                    element={
                      <CheckRoutes>
                        <Register />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/signin"
                    element={
                      <CheckRoutes>
                        <SignIn />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/signup"
                    element={
                      <CheckRoutes>
                        <SignUp />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/forgot-password"
                    element={
                      <CheckRoutes>
                        <ForgotPassword />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/reset-password"
                    element={
                      <CheckRoutes>
                        <Resetpassword />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/online-tutoring"
                    element={
                      <CheckRoutes>
                        <MCQService />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/expert-level-question-help"
                    element={
                      <CheckRoutes>
                        <TrueFalseService />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/fill-ups"
                    element={
                      <CheckRoutes>
                        <FillupsService />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/short-question-answer"
                    element={
                      <CheckRoutes>
                        <ShortAnswerService />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/match-the-following"
                    element={
                      <CheckRoutes>
                        <MatchTheFollowing />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-homework"
                    element={
                      <CheckRoutes>
                        <Definition />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-assignment"
                    element={
                      <CheckRoutes>
                        <AssignmentWriting />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-lab-report-writing"
                    element={
                      <CheckRoutes>
                        <ProjectLabReportWriting />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-essay-writing"
                    element={
                      <CheckRoutes>
                        <EssayWriting />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-presentation"
                    element={
                      <CheckRoutes>
                        <PresentationWriting />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-thesis-dissertation"
                    element={
                      <CheckRoutes>
                        <ArticleWriting />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/do-my-proposal-writing"
                    element={
                      <CheckRoutes>
                        <SpeechWriting />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/video-solutions"
                    element={
                      <CheckRoutes>
                        <VideoSolutions />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/do-my-project-report-writing"
                    element={
                      <CheckRoutes>
                        <ProjectReportWriting />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/write-my-research-paper"
                    element={
                      <CheckRoutes>
                        <ReseachPaper />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/blogs"
                    element={
                      <CheckRoutes>
                        <BlogsList />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/blogs/:slug"
                    element={
                      <CheckRoutes>
                        <BlogsDetail />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/assignment-help"
                    element={
                      <CheckRoutes>
                        <AssignmentHelp />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/1-1-chat"
                    element={
                      <CheckRoutes>
                        <LiveSessionChatHelp />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/1-1-video"
                    element={
                      <CheckRoutes>
                        <LiveSessionVideoHelp />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/search"
                    element={
                      <CheckRoutes>
                        <Search />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/homework-help/question-and-answer/:search"
                    element={
                      <CheckRoutes>
                        <ViewLibraryAnswer />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/:slug"
                    element={
                      <CheckRoutes>
                        <Refundpolicy />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/reviews"
                    element={
                      <CheckRoutes>
                        <Reviews />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/library"
                    element={
                      <CheckRoutes>
                        <Library />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/become-a-tutor"
                    element={
                      <CheckRoutes>
                        <Comingsoon />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/faqs"
                    element={
                      <CheckRoutes>
                        <Faq />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/all-subjects"
                    element={
                      <CheckRoutes>
                        <AllSubjects />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/subject/:slug"
                    element={
                      <CheckRoutes>
                        <SubjectCategory />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/:slug/:subslug"
                    element={
                      <CheckRoutes>
                        <SubjectSubcategory />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/practice-papers"
                    element={
                      <CheckRoutes>
                        <PracticePapers />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/exam-preparation"
                    element={
                      <CheckRoutes>
                        <ExamPreparation />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/question-bank"
                    element={
                      <CheckRoutes>
                        <QuestionBank />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/special-study-notes"
                    element={
                      <CheckRoutes>
                        <SepcialStudyNote />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/university-list"
                    element={
                      <CheckRoutes>
                        <UniversityList />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/university/:slug"
                    element={
                      <CheckRoutes>
                        <ParticularUniversity />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/after-university/:slug"
                    element={
                      <CheckRoutes>
                        <AfterUniversity />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="course/:universitySlug/:courseSlug"
                    element={
                      <CheckRoutes>
                        <ParticularCourse />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/thank-you"
                    element={
                      <CheckRoutes>
                        <ThankYou />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/transcript"
                    element={
                      <CheckRoutes>
                        <Demo />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/question"
                    element={
                      <CheckRoutes>
                        <Question />
                      </CheckRoutes>
                    }
                  />

                  <Route
                    path="/paynow"
                    element={
                      <CheckRoutes>
                        <PayNow />
                      </CheckRoutes>
                    }
                  />
                  <Route
                    path="/billingDetails/:paymentMethod/:questionId"
                    element={
                      <RequireAuth>
                        <BillingAddress />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/checkout"
                    element={
                      <RequireAuth>
                        <CheckoutContainer />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/billingDetailscourse/:paymentMethod/:courseId"
                    element={
                      <RequireAuth>
                        <BillingAddressCourse />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/checkout"
                    element={
                      <RequireAuth>
                        <CheckOut stripePromise={stripePromise} />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/course-checkout/:id"
                    element={
                      <RequireAuth>
                        <CourseCheckOut stripePromise={stripePromise} />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="/razorpay-checkout"
                    element={
                      <RequireAuth>
                        <Razorpay razorpayPromise={razorpayPromise} />
                      </RequireAuth>
                    }
                  />
                  <Route
                    path="dashboard"
                    element={
                      <RequireAuth>
                        <Dashboard />
                      </RequireAuth>
                    }
                  >
                    <Route path="completion" element={<Completion />} />
                    <Route
                      path="razorpay-completion"
                      element={<RazorpayCompletion />}
                    />
                    <Route path="failed" element={<OopsError />} />
                    <Route
                      path="home"
                      index
                      element={
                        <RequireAuth>
                          <DashboardHome />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/dashboard/orderStatus/:questionId"
                      index
                      element={
                        <RequireAuth>
                          <DashboardOrd />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="order-history"
                      element={
                        <RequireAuth>
                          <DashboardOrderHistory />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="exam-prep-history"
                      element={
                        <RequireAuth>
                          <ExamPrepHistory />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="dashboard-university"
                      element={
                        <RequireAuth>
                          <DashboardUniversity />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/dashboard/home/course/:universitySlug/:courseSlug"
                      element={
                        <RequireAuth>
                          <DashboardParticularCourse />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="paynow"
                      element={
                        <RequireAuth>
                          <DashboardPaynow />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="questions"
                      element={
                        <RequireAuth>
                          <DashboardQuestions />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="answer"
                      element={
                        <RequireAuth>
                          <DashboardAnswer />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="/dashboard/thank-you"
                      element={
                        <RequireAuth>
                          <DashboardThankYou />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path=":id"
                      element={
                        <RequireAuth>
                          <TrackOrder />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="earnmoney"
                      element={
                        <RequireAuth>
                          <Earnmoney />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="personal-info"
                      element={
                        <RequireAuth>
                          <PersonalSetting />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="referral-program"
                      element={
                        <RequireAuth>
                          <Referralprogram />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="viewanswer/:questionId"
                      element={
                        <RequireAuth>
                          <Dashboardview />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="viewanswer-homework/:questionId"
                      element={
                        <RequireAuth>
                          <DashboardviewHomework />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="viewanswer-live/:questionId"
                      element={
                        <RequireAuth>
                          <Dashboardviewlive />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="subjects"
                      element={
                        <RequireAuth>
                          <DashboardLibrary />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="subjects/question-and-answer/:search"
                      element={
                        <RequireAuth>
                          <Libraryviewabswer />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="faq"
                      element={
                        <RequireAuth>
                          <DashboardFaq />
                        </RequireAuth>
                      }
                    />
                    <Route
                      path="contact-us"
                      element={
                        <RequireAuth>
                          <DashboardContactUs />
                        </RequireAuth>
                      }
                    />
                  </Route>
                </Routes>
                 </div>

  {!shouldHideFooter && <Footer />}
              </Suspense>


            </SubSubjectsProvider>
          </CategoryContext.Provider>
        </ChatNotificationProvider>
      </div>
      <ToastContainer autoClose={1000} theme="colored" />
    </>
  );
}

export default App;
